












































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

import { ApplicationUserModel, FileModel } from '@/libs/Api';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { filesStore } from '@/libs/files/+state/store';

import CloudFiles from '@/libs/cloud/components/CloudFiles.vue';

import moment from 'moment';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { cloneDeep } from 'lodash';
import Page from '@/Page.vue';

@Component({
    components: { CloudFiles }
})
export default class CloudFileDetailDialog extends Page {

  show = false;
  valid = false;
  basicRules = [
    (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
  ];
  newComment: string | null = null;
  comments: Array<any> = [];
  id: string | null = null;
  itemToEdit: string | null = null;
  creating = false;
  downloading = false;
  
  @Watch("show")
  showChanged(v: boolean) {
    if (!v)
      this.close();
  }
  
  @Watch("deleting")
  deletingChanged(v: boolean, p: boolean) {
    if (v != p && !v) {
      this.show = false;
      this.$emit("deleted");
    }
  }

  @Prop({ default: true }) redirect!: boolean;
  @Ref() form!: any;
  @Ref() cloudFiles!: CloudFiles;

  get user(): ApplicationUserModel {
    return applicationUserStore.useGetter(CrudGetter.Detail);
  }

  get today(): string {
    return moment().format("DD.MM.YYYY");
  }

  get item() : FileModel {
    return {...filesStore.useGetter(CrudGetter.Detail, this.id)} as FileModel;
  }

  get saving() {
    return filesStore.useGetter(CrudGetter.Saving, this.id);
  }

  get deleting() {
    return filesStore.useGetter(CrudGetter.Deleting, this.id);
  }

  open (id: string) {
      this.show = true;
      this.id = id;
      filesStore.dispatch(CrudAction.Get, { id: id, key: this.id });
  }

  save () {
    if (this.form.validate()) {
      filesStore.dispatch(CrudAction.Update, { item: this.item, key: this.id });
      this.subscribe(filesStore, CrudReponse.Update, this.id).then(() => {
        this.$emit("refresh");
        this.close();
      });
    }
  }

  deleteFile () {
    filesStore.dispatch(CrudAction.Delete, { id: this.id, key: this.id });
    this.subscribe(filesStore, CrudReponse.Delete, this.id).then(() => {
      this.$emit("refresh");
      this.close();
    });
  }

  close () {
    this.show = false;
  }

  uploadFiles () {
    this.cloudFiles.uploadFiles();
  }

  downloadFile () {
    this.downloading = true;
    setTimeout(() => {
      this.$emit("downloadFile", this.id);
      this.downloading = false;
    }, 1500);
  }
  
}
